import React, { Component, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { iigBaseUrl } from "../../globalConfig";
import { getLocalstorage } from "../../helper";

export function ModalIIGCreateProjectDisabled(props) {
  const { show, handleClose } = props;

  const handleRedirection = () => {
    const accessToken = getLocalstorage("token");
    const url =
      `${iigBaseUrl}/pmg/project` +
      `?action=create` +
      `#t=${encodeURIComponent(accessToken)}`;
    console.log("url created", url);

    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      className="confirmation-modal iig-confirmation-modal"
    >
      <div class="confirm-icon" />
      <Modal.Header closeButton />
      <Modal.Body>
        <h4 class="page-heading">Create Project</h4>
        <p class="page-subline edit-project-for-iig">
          PMG has been integrated with CRIP (PAIMANA) Portal. Going forward all
          new projects <br /> must be created through CRIP (PAIMANA) portal
          only.
          <br /> <br />
          Projects created on CRIP (PAIMANA) will automatically get created on
          the PMG portal.
        </p>
        <div class="edit-project-iig-buttons justify-content-end d-flex">
          <div>
            <Button
              className="btn-orange-invert no-padding"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </div>
          <div>
            <a
              target="_blank"
              // href={`${iigBaseUrl}`}
            >
              <Button
                className="btn-orange no-padding"
                onClick={handleRedirection}
              >
                Go To CRIP Portal
              </Button>
            </a>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
